<ng-container *ngIf="formGroup; else onlyLayout">
  <form class="flex flex-col h-full" [formGroup]="formGroup" (ngSubmit)="submit()">
    <ng-container *ngTemplateOutlet="formContent"></ng-container>
  </form>
</ng-container>

<ng-template #onlyLayout>
  <ng-container *ngTemplateOutlet="formContent"></ng-container>
</ng-template>

<ng-template #formContent>
  <app-base-modal-body>
    <div class="profile-base-form-content">
      <h4 *ngIf="title && !isContentLoading" class="profile-base-form-title">{{ title | translate }}</h4>

      <ng-container *ngIf="!isContentLoading; else loader">
        <ng-content select="[form-controls]"></ng-content>
      </ng-container>
      <ng-template #loader>
        <app-loader />
      </ng-template>
    </div>
  </app-base-modal-body>

  <app-base-modal-footer>
    <ng-content select="[form-buttons]"></ng-content>
  </app-base-modal-footer>
</ng-template>
